import React, { FC, useCallback, useState } from "react";
import CheckboxField from "../../common/form/fields/CheckboxField";

export type GeometryType = "Point" | "LineString" | "Polygon";

const GeometryTypeSelect: FC<{ onChange: (value: GeometryType) => void; required: boolean; value: GeometryType }> = (props) => {
  const [alterType, setAlterType] = useState<"Point" | "LineString" | "Polygon">("Point");

  const AlterType: FC<{
    value: "Point" | "LineString" | "Polygon" | null;

    onChange: (field: "Point" | "LineString" | "Polygon") => void;
  }> = () => {
    const [value, setValue] = useState<"Point" | "LineString" | "Polygon">(props.value || "Point");

    const handleChange = useCallback((key: "Point" | "LineString" | "Polygon") => {
      setValue(key);
      debugger;
      props.onChange(key as GeometryType);
    }, []);

    return (
      <div
        style={{
          position: "fixed",
          top: 70,
          paddingLeft: 5,
          paddingRight: 5,
          paddingTop: 8,
          left: 0,
          border: 0,
          fontSize: 13,
          zIndex: 2000,
          textAlign: "center",
          width: "100%",
        }}
      >
        {["Point", "LineString", "Polygon"].map((type) => (
          <span
            key={type}
            style={{
              background: "rgba(255,255,255,0.7)",
              margin: 3,
              padding: 3,
              paddingTop: 10,
              paddingBottom: 8,
              borderRadius: 3,
              border: "solid 1px white",
            }}
          >
            {type}{" "}
            <CheckboxField
              field={{
                key: type,
                value: value === type,
                label: "",
                type: "checkbox",
              }}
              onChange={handleChange as (field: string) => void}
            />
          </span>
        ))}
      </div>
    );
  };

  return <AlterType value={alterType} onChange={setAlterType} />;
};

export default GeometryTypeSelect;
